export default __webpack_public_path__ + "static/media/asoebi.dc290fc1.png";